import { h, Component, Event, EventEmitter, Prop } from '@stencil/core';


@Component({
  tag: 'tip-options',
  styleUrl: 'options.css'
})
export class ProjectOption {
  @Prop() column: any;
  @Prop() feature: any;
  @Prop() value: boolean;
  @Prop({mutable: true}) expanded: boolean = false;
  @Prop({mutable: true}) hasHistory: boolean = true;
  @Prop({mutable: true}) latestRow: boolean = true;

  @Event() updateExpanded: EventEmitter;

  handleClick(_e) {
    this.expanded = !this.expanded;
    this.updateExpanded.emit({
      expanded: this.expanded,
      feature: this.feature
    });
  }

  renderHistory() {
    if (this.hasHistory && this.latestRow) {
      return (
        <div class='tooltip'>
          <i class="material-icons" onClick={(e) => this.handleClick(e)}>
          {this.expanded ? 'remove' : 'add'}</i>
          <span class="tooltiptext">
          {this.expanded ? 'Minimize Project History': 'Expand Project History'}
          </span>
        </div>
      )
    }
    if (!this.latestRow) {
      return 'History'
    }
  }

  componentWillRender() {
    this.latestRow = this.feature.properties['rowClassAttribute']
      .indexOf('latest') > -1
    this.hasHistory = this.feature.properties['rowClassAttribute']
      .indexOf('hasHistory') > -1
  }

  render() {
    return (
      <div class='project-option'>
        {this.renderHistory()}
      </div>
    )
  }
}
